import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ecNoOnlyWhiteSpacesValidator } from '@cf/core';
import {
  CfDialogButtonsDirective,
  CfDialogContentDirective,
  CfDialogDismissDirective,
  CfDialogTitleDirective,
  injectDialogData,
  injectDialogRef,
} from '@cf/shared/dialog';
import {
  FormFieldComponent,
  InputDirective,
  InputErrorComponent,
} from '@cf/shared/forms/form-field';
import { ButtonDirective } from '@cf/shared/ui/button';
import { CfIconDirective } from '@cf/shared/ui/icons';
import { LoaderContainerComponent } from '@cf/shared/ui/loading';
import { IAppEvent, SchemaAppEventDetail } from '@cf/temp/services';
import { NgxTolgeeModule } from '@tolgee/ngx';

export interface IEventRejectTentativeModalData {
  event: IAppEvent | SchemaAppEventDetail;
}

@Component({
  selector: 'cf-event-reject-tentative',
  templateUrl: './event-reject-tentative-modal.component.html',
  styleUrls: ['./event-reject-tentative-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgxTolgeeModule,
    CfDialogContentDirective,
    CfDialogDismissDirective,
    CfDialogTitleDirective,
    CfDialogButtonsDirective,
    CfIconDirective,
    ButtonDirective,
    FormFieldComponent,
    InputDirective,
    InputErrorComponent,
    LoaderContainerComponent,
  ],
})
export class EventRejectTentativeModalComponent {
  // Injections
  ref = injectDialogRef<string>();
  data = injectDialogData<IEventRejectTentativeModalData>();

  // Properties
  event = this.data.event;

  // Form controls
  reasonControl = new FormControl<string>('', [
    ecNoOnlyWhiteSpacesValidator,
    Validators.maxLength(500),
  ]);

  // Public methods
  rejectTentative(): void {
    if (this.reasonControl.invalid) return;
    const reason = this.reasonControl.value ?? '';
    this.ref.close(reason);
  }
}
